import { getOrCreatePulse } from '@tools/tracking/utils';
import { ClickObjID, StepID } from './types';

const EVENT_PREFIX =
  'sdrn:subito:content:fake-door-verified-user-listing:element:';

const trackClick = (objectID: ClickObjID, ctaLabel: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Engagement',
    action: 'Click',
    object: {
      elementType: 'button',
      label: ctaLabel,
      '@id': `${EVENT_PREFIX}${objectID}`,
      '@type': 'UIElement',
    },
  });
};

const trackView = (objectID: 'notice' | StepID): void => {
  getOrCreatePulse()?.queueEvent({
    object: {
      '@id': `${EVENT_PREFIX}${objectID}`,
      '@type': 'UIElement',
    },
    type: 'View',
  });
};

export { trackClick, trackView };
